import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DiscountContextType {
  selectedDiscount: number;
  setSelectedDiscount: (discount: number) => void;
  getDiscountLabel: (discount: number) => string;
}

const DiscountContext = createContext<DiscountContextType | undefined>(undefined);

interface DiscountProviderProps {
  children: ReactNode;
  defaultDiscount?: number;
}

export const DiscountProvider: React.FC<DiscountProviderProps> = ({
  children,
  defaultDiscount = 0.5,
}) => {
  const [selectedDiscount, setSelectedDiscount] = useState<number>(defaultDiscount);

  const getDiscountLabel = (discount: number): string => `${Math.round(discount * 100)}%`;

  return (
    <DiscountContext.Provider
      value={{
        selectedDiscount,
        setSelectedDiscount,
        getDiscountLabel,
      }}>
      {children}
    </DiscountContext.Provider>
  );
};

export const useDiscount = (): DiscountContextType => {
  const context = useContext(DiscountContext);
  if (context === undefined) {
    throw new Error('useDiscount must be used within a DiscountProvider');
  }
  return context;
};
